<!--
 * @Author: cryi.liu
 * @Date: 2020-05-01 15:38:55
 * @LastEditTime: 2020-06-16 14:25:39
 * @Description: 原 PSS 风格侧栏目录
 -->
<template>
  <div class="sider-menu">
    <div class="sider-menu-category">
      <span @click="routeToExamCenter">统考中心</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiderMenu',
  data() {
    return {
      menuList: [],
    };
  },
  methods: {
    routeToExamCenter() {
      window.open('/tr/portal/index.jsp', '_self');
    },
  },
};
</script>

<style lang="less" scoped>
.sider-menu {
  color: #0B446E;

  &-category {
    width: 100%;
    height: 29px;
    background: url('../../../../assets/image/sider-menu-category.jpg') no-repeat;

    > span {
      margin-left: 36px;
      line-height: 29px;
      font-size: 12px;
      font-weight: bold;
      cursor: pointer;
    }
  }
}
</style>
